module.exports = __webpack_public_path__ + "img/manufacture-badge.b7aaa133.png";